import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ContentAlignment, Link } from "fr-ito-web-react/react/esm";
import { NewImage } from "@common/index";
import { Caption } from "@common/DynamicUikit";
import { StylingType } from "@type/index";
import styles from "./styles.module.css";

type Props = {
  type: string;
  children?: ReactNode;
  hrefOfficial: string;
  hrefStylehint: string;
  onClickOfficial?: (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => void;
  onClickStylehint?: (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => void;
};

const TabTop = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.TabTop}>
      <ContentAlignment
        justifyContent={"center"}
        direction={"row"}
        alignment={"center"}
        className={styles.ContentAlignment}
      >
        <Link
          className={
            props.type === StylingType.official
              ? `${styles.ActiveLink} ${styles.Link}`
              : styles.Link
          }
          element="a"
          target="_self"
          onClick={props.onClickOfficial}
          href={props.hrefOfficial}
        >
          <Caption
            element="h1"
            color="primary-dark"
            className={
              props.type === StylingType.official
                ? `${styles.ActiveTab} ${styles.Tab}`
                : styles.Tab
            }
          >
            {t("text_styling_book_official_styling")}
          </Caption>
        </Link>
        <span className={styles.Divider} />
        <Link
          className={
            props.type === StylingType.stylehint
              ? `${styles.ActiveLink} ${styles.Link}`
              : styles.Link
          }
          element="a"
          target="_self"
          onClick={props.onClickStylehint}
          href={props.hrefStylehint}
        >
          <NewImage
            src="https://asset.uniqlo.com/g/icons/style-hint.svg"
            alt=""
            width="77px"
            height="22px"
          />
        </Link>
      </ContentAlignment>
      {props.children}
    </div>
  );
};

export default TabTop;
